export default {
  // Hero
  'hero.badge': 'Manufacturing Alliance',
  'hero.title': 'A Manufacturing Alliance of Large-Scale Factories',
  'hero.imageAlt': 'Manufacturing alliance factory complex',
  'hero.subtitle':
    'Four specialized, highly automated production facilities working together to supply cosmetic packaging directly to global brands.',
  'hero.message':
    'We are not a trading company connected to unknown suppliers. We are a manufacturing alliance formed by real, large-scale, highly automated factories. By combining the specialized capabilities of four major manufacturing facilities, we provide reliable quality, stable mass production, integrated supply, and highly competitive global pricing.',
  'hero.cta.quote': 'Request a Quote',
  'hero.cta.contact': 'Contact Our Team',
  'hero.scroll': 'Explore Our Factories',

  // Intro
  'intro.label': 'Our Supplier Network',
  'intro.title': 'Supplier Network, Reimagined',
  'intro.subtitle':
    'How our manufacturing alliance combines specialized factories into one integrated supply chain.',
  'intro.networkTitle': 'A unified alliance of specialized factories',
  'intro.networkDesc':
    'Instead of sourcing from disconnected, unverified suppliers, our manufacturing alliance brings four specialized production facilities under one coordinated operation. Each factory focuses on what it does best — glass, tubes, plastic, and full packaging — while sharing a single standard of quality, automation, and reliability.',
  'intro.stat.factories': '4',
  'intro.stat.factories.label': 'Specialized Factories',
  'intro.stat.automation': '4th Gen',
  'intro.stat.automation.label': 'Automated Production',
  'intro.stat.integrated': '1',
  'intro.stat.integrated.label': 'Integrated Supply Chain',

  // Factories
  'factories.label': 'Our Facilities',
  'factories.title': 'Meet the Four Factories',
  'factories.subtitle':
    'Each facility is a real, large-scale production base with 4th-generation automation and dedicated quality control.',

  // Factory common labels
  'factory.label': 'Factory',
  'factory.introduction': 'Introduction',
  'factory.products': 'Main Products',
  'factory.technology': 'Specialized Technology',
  'factory.automation': 'Automation & Capacity',
  'factory.capacity': 'Annual Capacity',
  'factory.established': 'Established',
  'factory.qc': 'Quality Control',

  // Gallery labels
  'gallery.title': 'Gallery',
  'gallery.scrollLeft': 'Scroll left',
  'gallery.scrollRight': 'Scroll right',
  'gallery.overview': 'Overview',
  'gallery.productionLine': 'Production Line',
  'gallery.automation': 'Automation Equipment',
  'gallery.qc': 'Quality Control',
  'gallery.warehouse': 'Warehouse',
  'gallery.rawMaterial': 'Raw Materials',
  'gallery.finished': 'Finished Products',
  'gallery.printing': 'Printing',
  'gallery.molding': 'Injection Molding',
  'gallery.assembly': 'Assembly',
  'gallery.decoration': 'Decoration',

  // Placeholders
  'placeholder.tbd': '[TBD]',
  'placeholder.pending': 'Information to be provided',

  // Glass Bottles Factory
  'factory.glass.name': 'Cristallo Glassworks Co., Ltd.',
  'factory.glass.tagline': 'Premium Glass Container Specialist',
  'factory.glass.history':
    'Founded in 2003 in Guangzhou, Cristallo Glassworks began as a single furnace workshop and grew into a 180,000 m² export-oriented production base. It now operates 12 automated glass-forming and annealing lines, serving more than 40 cosmetic brands across Europe, North America, and Japan.',
  'factory.glass.established': '2003',
  'factory.glass.capacity': '120M units / year',
  'factory.glass.product1': 'Cosmetic glass bottles',
  'factory.glass.product2': 'Glass dropper bottles',
  'factory.glass.product3': 'Glass cream jars',
  'factory.glass.product4': 'Perfume glass bottles',
  'factory.glass.spec1': 'Precision glass molding',
  'factory.glass.spec2': 'Color spraying & frosting',
  'factory.glass.spec3': 'Silk-screen & hot stamping',
  'factory.glass.spec4': 'High-transparency glass forming',
  'factory.glass.automation':
    'Equipped with 4th-generation automated glass forming, annealing, and inspection lines for high-volume, consistent production.',
  'factory.glass.qc':
    'Multi-stage inspection covering dimensional accuracy, transparency, pressure resistance, and surface finish, with full traceability.',

  // Cosmetic Tubes Factory
  'factory.tubes.name': 'FlexoTech Tube Industries',
  'factory.tubes.tagline': 'Laminate & Squeeze Tube Specialist',
  'factory.tubes.history':
    'Established in 1998, FlexoTech pioneered ABL tube lamination in the region. With three production campuses and 28 extrusion, printing, and filling lines, it supplies over 300 million tubes annually to global beauty and personal care brands.',
  'factory.tubes.established': '1998',
  'factory.tubes.capacity': '300M units / year',
  'factory.tubes.product1': 'Cosmetic laminate tubes',
  'factory.tubes.product2': 'Plastic squeeze tubes',
  'factory.tubes.product3': 'ABL / PBL tubes',
  'factory.tubes.product4': 'Airless tubes',
  'factory.tubes.spec1': 'Tube extrusion & lamination',
  'factory.tubes.spec2': 'Tube filling & sealing',
  'factory.tubes.spec3': 'Multi-color offset printing',
  'factory.tubes.spec4': 'Tube shoulder & cap molding',
  'factory.tubes.automation':
    'High-speed automated extrusion, multi-color printing, filling, and sealing lines ensure stable mass production.',
  'factory.tubes.qc':
    'Inspection of print quality, seal integrity, and material consistency with standardized QC protocols.',

  // Plastic Bottles Factory
  'factory.plastic.name': 'PolyForm Packaging Co., Ltd.',
  'factory.plastic.tagline': 'PET / PP Bottle Specialist',
  'factory.plastic.history':
    'Founded in 2006, PolyForm specializes in PET, PP, and PETG bottles. Its fully automated blow-molding plant operates around the clock with robotic sorting and inspection, delivering 500 million bottles a year to customers in more than 30 countries.',
  'factory.plastic.established': '2006',
  'factory.plastic.capacity': '500M units / year',
  'factory.plastic.product1': 'PET cosmetic bottles',
  'factory.plastic.product2': 'PP / PETG bottles',
  'factory.plastic.product3': 'Airless pump bottles',
  'factory.plastic.product4': 'Lotion & spray bottles',
  'factory.plastic.spec1': 'Injection stretch blow molding',
  'factory.plastic.spec2': 'Extrusion blow molding',
  'factory.plastic.spec3': 'Injection molding',
  'factory.plastic.spec4': 'Surface decoration & coating',
  'factory.plastic.automation':
    'Fully automated blow molding and robotic sorting systems deliver high-speed, precision mass production.',
  'factory.plastic.qc':
    'Dimensional, drop, and leak testing on every production batch ensures reliable, defect-free output.',

  // Cosmetic Packaging Manufacturer
  'factory.packaging.name': 'CosmePack Manufacturing Group',
  'factory.packaging.tagline': 'Integrated Packaging Solutions',
  'factory.packaging.history':
    'Since 1995, CosmePack has integrated decoration, assembly, and turnkey packaging into a single operation. As the flagship facility of our alliance, it manages complete OEM/ODM programs from material sourcing to finished, market-ready packaging.',
  'factory.packaging.established': '1995',
  'factory.packaging.capacity': 'Turnkey integrated supply',
  'factory.packaging.product1': 'Complete cosmetic packaging sets',
  'factory.packaging.product2': 'Caps, pumps & accessories',
  'factory.packaging.product3': 'Compact & cushion cases',
  'factory.packaging.product4': 'Custom OEM packaging',
  'factory.packaging.spec1': 'Full packaging assembly',
  'factory.packaging.spec2': 'Multi-process decoration',
  'factory.packaging.spec3': 'OEM / ODM solutions',
  'factory.packaging.spec4': 'Turnkey packaging supply',
  'factory.packaging.automation':
    'Integrated automated assembly and decoration lines with robotic handling enable flexible, high-volume packaging production.',
  'factory.packaging.qc':
    'End-to-end quality control from incoming materials to finished goods, including color matching and function testing.',

  // Integrated supply
  'integrated.label': 'Why We Deliver',
  'integrated.title': 'Integrated Supply, Unmatched Value',
  'integrated.subtitle':
    'By combining four specialized factories into a single alliance, we deliver what fragmented sourcing cannot.',
  'integrated.quality.title': 'Reliable Quality',
  'integrated.quality.desc':
    'Standardized QC across all four facilities ensures consistent, dependable output for every order.',
  'integrated.stability.title': 'Stable Mass Production',
  'integrated.stability.desc':
    '4th-generation automated lines deliver the volume and consistency required for large orders.',
  'integrated.supply.title': 'Integrated Supply',
  'integrated.supply.desc':
    'Source glass, tubes, and plastic packaging together from a single coordinated alliance.',
  'integrated.price.title': 'Competitive Global Pricing',
  'integrated.price.desc':
    'Direct factory sourcing without middlemen keeps costs transparent and globally competitive.',

  // Quality control
  'qc.label': 'Quality Assurance',
  'qc.title': 'Quality Control & Inspection',
  'qc.subtitle':
    'Every factory follows the same rigorous, multi-stage quality assurance process.',
  'qc.item1': 'Incoming material inspection',
  'qc.item2': 'In-process dimensional & visual checks',
  'qc.item3': 'Pressure & leak testing',
  'qc.item4': 'Print & color matching verification',
  'qc.item5': 'Function & assembly testing',
  'qc.item6': 'Pre-shipment final inspection',

  // CTA
  'cta.label': 'Start Sourcing',
  'cta.title': 'Ready to source with confidence?',
  'cta.subtitle':
    'Tell us about your packaging needs and get a direct quote from our manufacturing alliance.',
  'cta.quote': 'Request a Quote',
  'cta.contact': 'Contact Our Team',
};